import React, { useRef } from 'react';
import AudioPlayer from 'react-h5-audio-player';

export const useNonconcurrentPlay = () => {
  const trackPlayerRefs = useRef<Record<string, React.RefObject<AudioPlayer>>>({});

  const getTrackPlayerRef: (key: string) => React.Ref<AudioPlayer> = key => element => {
    if (!trackPlayerRefs.current[key] && element) {
      trackPlayerRefs.current[key] = { current: element };
    }
  };

  const composeOnPlay = (index: number) => () => {
    Object.values(trackPlayerRefs.current).forEach((trackPlayer, trackIndex) => {
      if (trackIndex !== index) {
        trackPlayer.current?.audio.current?.pause();
      }
    });
  };

  return { trackPlayerRefs, getTrackPlayerRef, composeOnPlay };
};
